import { render, staticRenderFns } from "./salary_pay.vue?vue&type=template&id=3582ad3c&scoped=true"
import script from "./salary_pay.vue?vue&type=script&lang=js"
export * from "./salary_pay.vue?vue&type=script&lang=js"
import style0 from "./salary_pay.vue?vue&type=style&index=0&id=3582ad3c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582ad3c",
  null
  
)

export default component.exports